export const JIRA_INTEGRATION_DETAIL_NAV = {
  CONFIGURATION: 'Configuration',
  AUTOMATION_RULES: 'Automation rules'
};

export const JIRA_INTEGRATION_DETAIL_LABELS = {
  PAGE_TITLE: 'Jira Cloud',
  GO_BACK: 'Go Back'
};

export const JIRA_CONNECTION_HEALTH_LABELS = {
  DISCONNECT: 'Disconnect',
  TEST_CONNECTION: 'Test connection',
  TESTING: 'Testing',
  CONNECTED: 'Connected',
  RECONNECT: 'Reconnect',
  REINSTALL: 'Reinstall',
  CONNECTION_HEALTH_TITLE: 'Connection health',
  CONNECTION_HEALTH_SUBTITLE: 'Active and working',
  CONNECTION_HEALTH_SUBTITLE_DISCONNECTED: 'Disconnected.',
  CONNECTION_HEALTH_SUBTITLE_AUTH_REQUIRED: 'Authorization required.',
  CONNECTION_HEALTH_SUBTITLE_APP_REMOVED: 'Installation incomplete. Finish setup in ',
  CONNECTION_HEALTH_SUBTITLE_RECONNECT_RESUME: 'Reconnect to resume',
  CONNECTION_HEALTH_SUBTITLE_ATLASSIAN_MARKETPLACE: 'Atlassian Marketplace',
  CONNECTION_HEALTH_SUBTITLE_RECONNECT_JIRA: 'Reconnect Jira restore',
  ALERT_DISCONNECTED: 'Jira integration is disconnected. Reconnect to enable Jira ticket creation.',
  ALERT_AUTH_EXPIRED: 'Jira authorization has expired. Reconnect to enable Jira ticket creation.',
  ALERT_APP_REMOVED: 'NetRise app was removed from Jira. Reinstall to enable Jira ticket creation.',
  RECONNECT_SUCCESS: 'Jira integration reconnected.',
  RECONNECT_ERROR: 'Failed to reconnect Jira integration.'
};

export const JIRA_CONNECTION_HEALTH_ISSUE = {
  DISCONNECTED: 'DISCONNECTED',
  AUTH_EXPIRED: 'AUTH_EXPIRED',
  APP_REMOVED: 'APP_REMOVED'
};

export const JIRA_CONNECTION_HEALTH_LINK_ACTION = {
  RECONNECT: 'RECONNECT',
  OPEN_MARKETPLACE: 'OPEN_MARKETPLACE',
  OPEN_AUTHORIZATION: 'OPEN_AUTHORIZATION'
};

export const JIRA_CONNECTION_METRIC_LABELS = {
  CONNECTED_SPACES: 'Jira spaces',
  LAST_UPDATED: 'Last updated',
  DISCONNECTED_ON: 'Disconnected on',
  EXPIRED: 'Expired',
  APP_REMOVED: 'App removed'
};

export const JIRA_SYSTEM_CHECK_STATUS = {
  ACTIVE: 'ACTIVE',
  WARNING: 'WARNING',
  ERROR: 'ERROR'
};

/** UI-only card status (not from GraphQL); shows a spinner instead of a system-check icon. */
export const JIRA_STATUS_MAPPING_PROBLEM_CARD_STATUS = {
  LOADING: 'LOADING'
};

export const JIRA_DISCONNECT_MODAL_LABELS = {
  TITLE: 'Disconnect Atlassian Jira?',
  CANCEL: 'Cancel',
  CONFIRM: 'Disconnect',
  SUCCESS: 'Jira integration disconnected.',
  ERROR: 'Failed to disconnect Jira integration.',
  CONSEQUENCE: "You won't be able to create new Jira tickets from NetRise findings until you reconnect."
};

export const JIRA_TEST_CONNECTION_LABELS = {
  SUCCESS: 'Jira connection is healthy.',
  ERROR: 'Jira connection test failed.'
};

export const JIRA_STATUS_MAPPING_LABELS = {
  TITLE: 'Status mapping',
  CARD_TITLE: 'Auto-Sync Jira issue status with NetRise',
  CARD_SUBTITLE: 'Set up automatic sync for NetRise status, in accordance with your Jira status',
  TOGGLE_LABEL_ENABLED: 'Enabled',
  TOGGLE_LABEL_DISABLED: 'Disabled',
  UPDATE_SUCCESS: 'Status mapping auto-sync updated.',
  UPDATE_ERROR: 'Failed to update status mapping auto-sync.'
};

/** Stable string codes from Turbine `JiraMappingProblem.code` (proto field is string, not an enum). */
export const JIRA_MAPPING_PROBLEM_CODE = {
  STATUS_NOT_MAPPED: 'STATUS_NOT_MAPPED',
  /** Legacy alias used in earlier mocks; prefer STATUS_NOT_MAPPED. */
  NO_NETRISE_MAPPING: 'NO_NETRISE_MAPPING',
  STATUS_NOT_FOUND: 'STATUS_NOT_FOUND',
  ILLEGAL_TRANSITION: 'ILLEGAL_TRANSITION'
};

export function isJiraStatusNotMappedProblemCode(code) {
  return code === JIRA_MAPPING_PROBLEM_CODE.STATUS_NOT_MAPPED || code === JIRA_MAPPING_PROBLEM_CODE.NO_NETRISE_MAPPING;
}

export const JIRA_CONFIG_PROBLEM_CODE = {
  JIRA_API_ERROR: 'JIRA_API_ERROR'
};

export const JIRA_STATUS_MAPPING_PROBLEM_CATEGORY = {
  STATUS_MAPPING: 'STATUS_MAPPING',
  OTHER: 'OTHER'
};

export const JIRA_STATUS_MAPPING_PROBLEM_LABELS = {
  HEALTHY_SUBTITLE: 'All mappings are valid',
  PAUSED_DISCONNECTED: 'Status sync is paused while Jira is disconnected.',
  PAUSED_AUTH_EXPIRED: 'Status sync is paused until Jira authorization is restored.',
  PAUSED_APP_REMOVED: 'Status sync is paused until the NetRise app is reinstalled in Jira.',
  ATTENTION_NEEDED: 'Attention needed ({count})',
  ATTENTION_NEEDED_SUBTITLE: 'Review and resolve to keep sync running.',
  COLUMN_STATUS_MAPPING: 'Status mapping',
  COLUMN_TIME: 'Time',
  COLUMN_OTHER: 'Other',
  VULN_DRAWER_WARNING: 'Status sync needs attention ({count}). ',
  VULN_DRAWER_WARNING_LINK_FALLBACK: 'Fix mappings'
};

export function getAttentionNeededTitle(count) {
  return JIRA_STATUS_MAPPING_PROBLEM_LABELS.ATTENTION_NEEDED.replace('{count}', String(count));
}
